// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Gl1r","overflowing":"ReadFullNote_overflowing__2FEZ_"};